<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppTitleHeader from '@/components/app/TitleHeader.vue';

  export default {
    props: {
      details: {
        type: Object || null,
        default: null,
      },
    },
    components: {
      AppTitleHeader,
    },
  };
</script>
<template>
  <v-row class="vehicle-checklist">
    <v-col cols="12">
      <v-row v-for="{ id, title, checkListCategoryItems } in details" :key="id">
        <v-col cols="12">
          <app-title-header :title="title" />
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="2" v-for="{ id, title, value } in checkListCategoryItems" :key="id">
              <div class="flex-gap-2">
                <v-icon v-if="value" color="darkColor">mdi-checkbox-marked-outline mdi-24px</v-icon>
                <v-icon v-else color="darkColor">mdi-checkbox-blank-outline mdi-24px</v-icon>
                <div>
                  {{ title }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<style lang="scss">
  .vehicle-checklist {
    height: 75vh;
    overflow-y: auto;
  }
</style>
